import { Injectable } from '@angular/core';

@Injectable()
export class TraceActions {

    static UPDATE = '[Trace] UPDATE';
    static SELECTALL = '[Trace] SELECTALL';
    static CHANGESTATE = '[Trace] CHANGESTATE';

    public Update(parent: string,  nodes: ITraceNode[], changeState: boolean): any {
        return {
            type:  TraceActions.UPDATE,
            payload: {
                parent,
                nodes,
                changeState
            }
        };
    }

    public SelectAll(select: boolean): any {
        return {
            type: TraceActions.SELECTALL,
            payload : select
        }
    }

    public ChangeState(change: boolean): any {
        return {
            type: TraceActions.CHANGESTATE,
            payload : change
        }
    }
}
